import React, { useMemo } from "react"
import { useHistory, useLocation } from "react-router-dom"
import SettingsPageSimple from "components-old/common/SettingsPage/SettingsPageSimple"
import { isAldeia } from "hooks/useAldeia"
import StarAlert from "pages/settings/channels/StarAlert"

interface BreadcrumbStep {
  title: string
  icon?: React.ReactNode
  lastPath: string
  children: React.ReactNode
  parentPath?: string
  backTo?: string
  helpText?: React.ReactNode
  description?: React.ReactNode
}

interface SettingsPageBreadcrumbProps {
  className?: string
  basePath?: string
  steps: Record<string, BreadcrumbStep>
}

function SettingsPageBreadcrumb({ steps, basePath, ...props }: SettingsPageBreadcrumbProps) {
  const history = useHistory()
  const location = useLocation()

  const { previousSteps, currentStep } = useMemo(() => {
    let previousSteps: BreadcrumbStep[] = []
    let currentStep: BreadcrumbStep | undefined
    const split = location.pathname.split("/")

    for (let i = 0; i < split.length; i++) {
      const path = split[i]
      if (steps?.[path]) {
        if (i === split.length - 1) {
          currentStep = steps?.[path]
        } else {
          previousSteps.push(steps?.[path])
        }
      }
    }

    if (!currentStep) {
      currentStep = previousSteps[previousSteps.length - 1]
      previousSteps = previousSteps.slice(0, -1)
    }

    return { previousSteps, currentStep }
  }, [steps, location.pathname])

  return (
    <SettingsPageSimple
      {...props}
      title={
        isAldeia ? (
          <span className="flex gap-2 items-center">
            {previousSteps.map((step, index) => (
              <>
                <span key={step.lastPath} className="flex gap-2 items-center opacity-30">
                  {step.icon}
                  {step.title}
                </span>{" "}
                {/* <IconMaterialSymbolsArrowRightAlt className="opacity-30" /> */}
                <IconCiCaretRightSm className="opacity-30 !size-[24px]" />
              </>
            ))}
            <span className="flex gap-2 items-center">
              {currentStep?.icon}
              {currentStep?.title}
            </span>
          </span>
        ) : (
          currentStep?.title || ""
        )
      }
      tabTitle={currentStep?.title || ""}
      backTo={currentStep?.backTo || ""}
      onBack={!!currentStep?.backTo ? () => history.push(currentStep?.backTo || "") : undefined}
      className={isAldeia ? "g_settings_simple_page" : ""}
      style={{ maxWidth: isAldeia ? undefined : 642 }}
      helpText={currentStep?.helpText || ""}
    >
      {!!currentStep?.description && (
        <>
          {isAldeia ? (
            currentStep?.description ? (
              <StarAlert className="mt-2 mb-5">{currentStep?.description || ""}</StarAlert>
            ) : null
          ) : (
            <div
              style={{
                fontSize: 16,
                color: "var(--content-secondary)",
                marginLeft: 5,
                marginBottom: 20,
              }}
            >
              {currentStep?.description || ""}
            </div>
          )}
        </>
      )}

      {currentStep?.children}
    </SettingsPageSimple>
  )
}

export default SettingsPageBreadcrumb
